import { render } from "./UploadPhotosPopUp.vue?vue&type=template&id=4861dfee&scoped=true&ts=true"
import script from "./UploadPhotosPopUp.vue?vue&type=script&lang=ts"
export * from "./UploadPhotosPopUp.vue?vue&type=script&lang=ts"

import "./UploadPhotosPopUp.vue?vue&type=style&index=0&id=4861dfee&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4861dfee"]])

export default __exports__